import { first, partition } from 'lodash/fp';
import formatCurrency from '@ahmdigital/logic/lib/claim/format-currency';

import { Bracket, Maybe, Rate, Tier } from '../../../../../../../types/__codegen__/sanity/graphql';

const BRACKET_TYPES = {
  couplesAndFamilies: 'Couples and Families',
  singles: 'Singles',
};

type FormattedBracketRow = {
  couplesAndFamilies: string;
  mls: string;
  singles: string;
};

const formatRange = (min: Maybe<number>, max: Maybe<number>): string => {
  const toWholeDollarAmount = (value: number) => formatCurrency(value, { minimumFractionDigits: 0 });

  if (min === 0 && max != null) return `<${toWholeDollarAmount(max)}`;
  if (min != null && max != null) return `${toWholeDollarAmount(min)} - ${toWholeDollarAmount(max)}`;
  if (min != null && max == null) return `>${toWholeDollarAmount(min)}`;
  return '';
};

const formatSanityBrackets = (data: Rate): FormattedBracketRow[] => {
  // Get brackets by type
  const [singlesBracket, couplesFamiliesBracket] = partition(
    (bracket: Bracket) => bracket?.bracketType?.name === BRACKET_TYPES.singles,
    data?.brackets,
  );

  const singles = (first(singlesBracket) as Bracket)?.tiers ?? [];
  const couplesFamilies = (first(couplesFamiliesBracket) as Bracket)?.tiers ?? [];

  // Build rows
  return singles.map((singleTier: Maybe<Tier>, index: number) => {
    const coupleAndFamiliesTier = couplesFamilies[index];
    return {
      couplesAndFamilies: coupleAndFamiliesTier
        ? formatRange(coupleAndFamiliesTier.tierMinimum ?? null, coupleAndFamiliesTier.tierMaximum ?? null)
        : '',
      mls: singleTier && singleTier.rate != null ? `${singleTier.rate.toFixed(2)}%` : '',
      singles: singleTier ? formatRange(singleTier.tierMinimum ?? null, singleTier.tierMaximum ?? null) : '',
    };
  });
};

export default formatSanityBrackets;
